function Vip({ isDark }) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 12"
      width="30"
      height="30"
    >
      <rect
        x=".5"
        y="2.5"
        width="12"
        height="9"
        style={{ fill: 'none', stroke: '#3175ff', strokeMiterlimit: 10 }}
      />
      <rect x="0" y="2" width="13" height="1" style={{ fill: '#ff6f15' }} />
      <rect x="1" width="11" height="2" style={{ fill: '#ee2d53' }} />
      <rect x="0" y="1" width="13" height="1" style={{ fill: '#ee2d53' }} />
      <text
        transform="translate(1.5 9.5)"
        style={{
          fill: isDark ? '#ffffff' : '#474747',
          fontFamily: 'AdobeClean-Bold, "Adobe Clean"',
          fontSize: '7px',
          fontWeight: 700,
          isolation: 'isolate',
        }}
      >
        <tspan x="0" y="0">
          VIP
        </tspan>
      </text>
    </svg>
  );
}

export default Vip;